import { FormattedMessage } from 'react-intl';

interface HeaderItem {
  id: number;
  label: JSX.Element | string;
  path?: string;
  isDropdown?: boolean;
  children?: HeaderItem[];
}

export const items: HeaderItem[] = [
  {
    id: 1,
    label: <FormattedMessage id="ToolsNavbarText" />,
    isDropdown: true,
    children: [
      {
        id: 6,
        label: <FormattedMessage id="IpCheckText" />,
        path: '/tools/ip-check',
      },
      {
        id: 7,
        label: <FormattedMessage id="EmailCheckText" />,
        path: '/tools/email-check',
      },
      {
        id: 8,

        label: <FormattedMessage id="TelegramCheckText" />,
        path: '/tools/telegram-check',
      },
      {
        id: 9,
        label: <FormattedMessage id="DdosSecurityText" />,
        path: '/tools/ddos-security',
      },
    ],
  },
  {
    id: 2,
    label: <FormattedMessage id="PricingNavbarText" />,
    path: '/pricing',
  },
  // {
  //   id: 3,
  //   label: <FormattedMessage id="PartnersNavbarText" />,
  //   path: '/partners',
  // },
  {
    id: 4,
    label: <FormattedMessage id="NewsNavbarText" />,
    path: 'news-all',
  },
  {
    id: 5,
    label: 'API Docs',
    // path: '/api-docs/getting-started',
    path: 'https://docs.ipscore.app/',
  },
  {
    id: 6,
    label: 'Contacts',
    path: '/contacts',
  },
];
